/** Hoisted so the two stacked fills of the "p" do not repeat a 1.4 KB literal. */
const PI_P_PATH =
  "M20.0001 65.4795H10.4092V17.8269H20.1143V22.9504C20.4188 22.2056 21.0785 21.3581 22.0934 20.4079C23.1083 19.4577 24.4277 18.6359 26.0515 17.9425C27.7008 17.249 29.5784 16.9023 31.6843 16.9023C34.6529 16.9023 37.241 17.6343 39.4484 19.0981C41.6558 20.562 43.3558 22.5652 44.5483 25.1077C45.7662 27.6245 46.3752 30.4752 46.3752 33.6597C46.3752 36.8443 45.7409 39.7078 44.4722 42.2503C43.2036 44.7671 41.4402 46.7574 39.182 48.2213C36.9238 49.6595 34.2977 50.3786 31.3037 50.3786C29.0455 50.3786 27.1045 49.9677 25.4806 49.1458C23.8568 48.324 22.5881 47.3995 21.6747 46.3722C20.7613 45.3449 20.2031 44.536 20.0001 43.9453V65.4795ZM36.8984 33.6597C36.8984 31.8877 36.5178 30.3339 35.7567 28.9985C35.0208 27.6373 34.0313 26.5844 32.788 25.8396C31.5448 25.0692 30.1619 24.6839 28.6396 24.6839C27.0411 24.6839 25.5948 25.0692 24.3008 25.8396C23.0068 26.6101 21.9792 27.6759 21.218 29.037C20.4822 30.3724 20.1143 31.9134 20.1143 33.6597C20.1143 35.4061 20.4822 36.9598 21.218 38.321C21.9792 39.6564 23.0068 40.7094 24.3008 41.4798C25.5948 42.2246 27.0411 42.597 28.6396 42.597C30.1619 42.597 31.5448 42.2246 32.788 41.4798C34.0313 40.7351 35.0208 39.6949 35.7567 38.3595C36.5178 36.9984 36.8984 35.4318 36.8984 33.6597Z";
const PI_STEM_PATH = "M49.3574 49.4523V17.8252H58.9864V49.4523H49.3574Z";

type PiLogoProps = {
  className?: string;
  height?: number;
  /** Unique per rendered instance so SVG gradient ids never clash on the page. */
  idPrefix: string;
};

/** Pi by Physics Wallah wordmark, used in the header and footer. */
export function PiLogo({ className, height = 32, idPrefix }: PiLogoProps) {
  const gradientIdPrefix = `pi-logo-${idPrefix}`;

  return (
    <svg
      height={height}
      viewBox="0 0 134 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Pi by Physics Wallah"
    >
      <circle
        cx="53.7818"
        cy="8.22715"
        r="5.20469"
        fill={`url(#${gradientIdPrefix}-0)`}
      />
      <circle
        cx="53.7818"
        cy="8.22715"
        r="5.20469"
        fill={`url(#${gradientIdPrefix}-1)`}
      />
      <path d={PI_STEM_PATH} fill={`url(#${gradientIdPrefix}-2)`} />
      <path d={PI_STEM_PATH} fill={`url(#${gradientIdPrefix}-3)`} />
      <path d={PI_P_PATH} fill={`url(#${gradientIdPrefix}-4)`} />
      <path d={PI_P_PATH} fill={`url(#${gradientIdPrefix}-5)`} />
      <rect
        x="72.8657"
        y="16.1924"
        width="60.5056"
        height="37.0111"
        rx="9.25279"
        fill={`url(#${gradientIdPrefix}-6)`}
      />
      <path
        d="M85.89 36.524V33.9319H88.411C88.9193 33.9319 89.3598 33.8336 89.7325 33.6371C90.1121 33.4338 90.4035 33.1559 90.6068 32.8035C90.8169 32.4511 90.9219 32.0479 90.9219 31.5938C90.9219 30.889 90.6847 30.3367 90.2103 29.9369C89.7359 29.5302 89.0955 29.3269 88.2891 29.3269H85.89V26.7144H88.472C89.5699 26.7144 90.5153 26.911 91.3082 27.304C92.1079 27.6971 92.7212 28.2528 93.1481 28.9711C93.5751 29.6895 93.7885 30.5332 93.7885 31.5023C93.7885 32.4918 93.5717 33.366 93.138 34.125C92.7042 34.8773 92.0943 35.4668 91.3082 35.8938C90.5288 36.314 89.614 36.524 88.5635 36.524H85.89ZM83.5926 41.6982V26.7144H86.4999V41.6982H83.5926ZM97.7226 36.2699V33.8709H100.498C100.999 33.8709 101.44 33.776 101.819 33.5862C102.199 33.3965 102.494 33.1322 102.704 32.7933C102.92 32.4477 103.029 32.0479 103.029 31.5938C103.029 30.889 102.785 30.3367 102.297 29.9369C101.809 29.5302 101.169 29.3269 100.376 29.3269H97.7226V26.7144H100.833C101.789 26.7144 102.646 26.8906 103.405 27.243C104.171 27.5954 104.777 28.1071 105.225 28.778C105.672 29.4489 105.896 30.2689 105.896 31.238C105.896 32.18 105.665 33.0305 105.204 33.7896C104.743 34.5486 104.083 35.1517 103.222 35.599C102.361 36.0463 101.335 36.2699 100.142 36.2699H97.7226ZM95.6895 41.6982V26.7144H98.5968V41.6982H95.6895ZM103.883 41.6982L100.437 35.8531L102.622 34.125L107.176 41.6982H103.883ZM115.39 41.8609C114.319 41.8609 113.32 41.6677 112.391 41.2815C111.47 40.8952 110.66 40.353 109.962 39.655C109.264 38.957 108.718 38.1437 108.325 37.2153C107.939 36.2869 107.746 35.2805 107.746 34.1962C107.746 33.1186 107.939 32.1156 108.325 31.1872C108.718 30.2588 109.26 29.4489 109.952 28.7577C110.65 28.0664 111.459 27.5277 112.381 27.1414C113.31 26.7483 114.306 26.5518 115.37 26.5518C116.454 26.5518 117.457 26.7483 118.379 27.1414C119.307 27.5277 120.117 28.0664 120.808 28.7577C121.506 29.4489 122.045 30.2588 122.425 31.1872C122.811 32.1156 123.004 33.122 123.004 34.2063C123.004 35.2839 122.811 36.2869 122.425 37.2153C122.045 38.1437 121.506 38.957 120.808 39.655C120.117 40.353 119.311 40.8952 118.389 41.2815C117.467 41.6677 116.468 41.8609 115.39 41.8609ZM115.36 39.2077C116.037 39.2077 116.661 39.079 117.23 38.8214C117.806 38.5639 118.308 38.2081 118.734 37.7541C119.168 37.3 119.504 36.7714 119.741 36.1683C119.978 35.5583 120.097 34.901 120.097 34.1962C120.097 33.4778 119.975 32.8171 119.731 32.2139C119.493 31.604 119.158 31.0754 118.724 30.6281C118.297 30.1808 117.796 29.8318 117.22 29.5811C116.644 29.3303 116.024 29.2049 115.36 29.2049C114.702 29.2049 114.089 29.3303 113.52 29.5811C112.95 29.8318 112.452 30.1808 112.025 30.6281C111.598 31.0754 111.263 31.604 111.019 32.2139C110.775 32.8171 110.653 33.4778 110.653 34.1962C110.653 34.901 110.772 35.5583 111.009 36.1683C111.253 36.7782 111.585 37.3102 112.005 37.7642C112.432 38.2183 112.93 38.5741 113.499 38.8316C114.075 39.0823 114.695 39.2077 115.36 39.2077Z"
        fill="#09090B"
      />
      <defs>
        <linearGradient
          id={`${gradientIdPrefix}-0`}
          x1="53.7818"
          y1="3.02246"
          x2="53.7818"
          y2="13.4318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84CAFF" />
          <stop offset="1" stopColor="#FDA29B" />
        </linearGradient>
        <linearGradient
          id={`${gradientIdPrefix}-1`}
          x1="53.7818"
          y1="3.02246"
          x2="53.7818"
          y2="13.4318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF440" />
          <stop offset="1" stopColor="#FDBD38" />
        </linearGradient>
        <linearGradient
          id={`${gradientIdPrefix}-2`}
          x1="54.1719"
          y1="17.8252"
          x2="54.1719"
          y2="49.4523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84CAFF" />
          <stop offset="1" stopColor="#FDA29B" />
        </linearGradient>
        <linearGradient
          id={`${gradientIdPrefix}-3`}
          x1="54.1719"
          y1="17.8252"
          x2="54.1719"
          y2="49.4523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF440" />
          <stop offset="1" stopColor="#FDBD38" />
        </linearGradient>
        <linearGradient
          id={`${gradientIdPrefix}-4`}
          x1="28.3922"
          y1="16.9023"
          x2="28.3922"
          y2="65.4795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84CAFF" />
          <stop offset="1" stopColor="#FDA29B" />
        </linearGradient>
        <linearGradient
          id={`${gradientIdPrefix}-5`}
          x1="28.3922"
          y1="16.9023"
          x2="28.3922"
          y2="65.4795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF440" />
          <stop offset="1" stopColor="#FDBD38" />
        </linearGradient>
        <linearGradient
          id={`${gradientIdPrefix}-6`}
          x1="103.119"
          y1="16.1924"
          x2="103.119"
          y2="53.2035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF440" />
          <stop offset="1" stopColor="#FDBD38" />
        </linearGradient>
      </defs>
    </svg>
  );
}
